// extracted by mini-css-extract-plugin
export default {"links":"NavLink_links__c1NYP"};